import React from 'react';
import List from 'shared/layout/list';
import useProjection from 'shared/migration-hooks/use-projection';
import {ProductReportProps} from '../types';
import toBrl from 'shared/util/to-brl';
import dateFnsService from 'shared/services/date-fns-service';
import todayFilter from 'shared/util/today-filter';

const ProductsReports: React.FC = () => {
  const projection = useProjection<ProductReportProps>(
    'productsReports',
    ['name', 'quantity', 'total', 'createdAt'],
    {defaultFilters: {createdAt: JSON.stringify(todayFilter) as any}},
  );

  return (
    <List<ProductReportProps>
      {...{
        titleBar: {title: 'Relatório de produtos'},
      }}
      dateFilter={{startDateField: 'createdAt'}}
      table={{
        url: '/reports/products',
        projection: {
          ...projection,
          options: [
            'name',
            {value: 'quantity', filter: {valueAsNumber: true}},
            {
              value: 'total',
              column: (row) => toBrl(row.total),
              filter: {valueAsNumber: true},
            },
            {
              value: 'createdAt',
              column: (row) =>
                row.createdAt && dateFnsService.dateTimeFormat(row.createdAt),
              hideFilter: true,
            },
          ],
        },
        translatedPropsKey: 'ProductReportProps',
      }}
    />
  );
};

export default ProductsReports;
